//Utils
import EventBus from "js-event-bus";
import firebase from "../../utils/firebase";
const eventBus = EventBus();
const uuid = require("uuid/v4");

export const createFaceSticker = (data) => {
  return async (dispatch, getState) => {
    try {
      let uniqueId = `effect_${uuid()}`;
      const firestore = firebase.firestore();
      let verifySticker = firestore.collection("faceStickers").doc(uniqueId);
      let verifyStickerDoc = await verifySticker.get();

      if (!verifyStickerDoc.exists) {
        await firebase
          .storage()
          .ref(`assets_faceStickers/${uniqueId}/deepAR`)
          .put(data.deepARFile);
        let url = await firebase
          .storage()
          .ref(`assets_faceStickers/${uniqueId}`)
          .child("deepAR")
          .getDownloadURL();
        await firestore.collection("faceStickers").doc(uniqueId).set({
          id: uniqueId,
          effect: url,
          name: data.selectedSticker.name.trim(),
        });
        eventBus.emit("sticker-function-success");
      } else
        eventBus.emit(
          "sticker-function-error",
          null,
          "The face sticker has been created"
        );
    } catch (err) {
      eventBus.emit("sticker-function-error", null, err);
    }
  };
};

export const deleteFaceSticker = (data) => {
  return async (dispatch, getState) => {
    try {
      const firestore = firebase.firestore();
      let verifySticker = firestore.collection("faceStickers").doc(data.id);
      await verifySticker.delete();
      await firebase
        .storage()
        .ref(`assets_faceStickers/${data.id}`)
        .child("deepAR")
        .delete();
      eventBus.emit("sticker-function-success");
    } catch (err) {
      eventBus.emit("sticker-function-error", null, err);
    }
  };
};
